<template>
  <div class="filter-block">
    <div class="filter-block__header">
      {{ header }}
    </div>

    <div class="filter-block__container">
      <oie-base-checkbox
        v-for="(filter, i) of filters"
        :key="`${filter.key}-${i}-${index}`"
        size="large"
        :is-for="`${filter.key}-${i}-${index}`"></oie-base-checkbox>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    header: {
      type: String,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    filters: []
  })
}
</script>
